import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <p>Initializing Stan IDE...</p>
      </div>
    </div>
  );
};

export const MenuBar: React.FC = () => {
  return (
    <div className="menu-bar">
      <div className="menu-items">
        <div className="menu-item">File</div>
        <div className="menu-item">Edit</div>
        <div className="menu-item">Assets</div>
        <div className="menu-item">GameObject</div>
        <div className="menu-item">Component</div>
        <div className="menu-item">Window</div>
        <div className="menu-item">Help</div>
      </div>
    </div>
  );
};

export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, token } = useAuthStore();
  
  // Check if we have a token in store or local storage
  const hasToken = isAuthenticated || token || localStorage.getItem('stan_token');

  if (!hasToken) {
    return (
      <div className="auth-guard-screen" style={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#0a0a0f', 
        color: 'white',
        fontFamily: 'Inter, sans-serif'
      }}>
        <h2>Login Required</h2>
        <p style={{ opacity: 0.7, marginBottom: 24 }}>You need to be logged in to access this project.</p>
        <a 
          href="https://stan.stanlink.online/#/auth" 
          style={{
            padding: '12px 24px',
            background: '#9c27b0',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 'bold'
          }}
        >
          Login via Dashboard
        </a>
      </div>
    );
  }
  
  return <>{children}</>;
};
